<template>
  <el-row class="person-container">
    <el-col :span="24"
            class="mb-15">
      <el-button v-has="'/department/add'"
                 type="primary"
                 @click="handleAdd">新增</el-button>
      <!-- <el-button type="primary"
                 @click="multipleDelete">批量删除</el-button> -->
    </el-col>
    <el-col :span="12"
            :xs="24">
      <el-card shadow="none">
        <el-tree ref="personTree"
                 highlight-current
                 default-expand-all
                 show-checkbox
                 node-key="id"
                 :expand-on-click-node="false"
                 :data="treeData"
                 :props="defaultProps">
          <span class="custom-tree-node"
                slot-scope="{ node, data }">
            <span>{{ node.label + '（ ' + (data.code || '暂无') + ' ）' }}</span>
            <span>
              <el-link v-has="'/department/add'"
                       class="mr-10"
                       type="primary"
                       icon="el-icon-circle-plus-outline"
                       @click="() => handleAdd(data)"></el-link>
              <el-link v-has="'/department/edit'"
                       class="mr-10"
                       type="primary"
                       icon="el-icon-edit"
                       @click="() => handleEdit(data)"></el-link>
              <el-link v-has="'/department/del'"
                       type="danger"
                       icon="el-icon-delete"
                       @click="() => handleDelete(data)"></el-link>
            </span>
          </span>
        </el-tree>
      </el-card>
    </el-col>
    <add-person v-if="showPersonModal"
                :isShow="showPersonModal"
                :data="personData"
                @handleClose="closePersonModal"></add-person>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
import AddPerson from '@/views/basic/person/AddPerson'
export default {
  components: { AddPerson },
  data() {
    return {
      searchForm: {
        keyword: '',
        status: ''
      },
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      treeData: [],
      // 添加机构相关
      showPersonModal: false,
      personData: {
        type: 'add'
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取数据
    getList() {
      fetch.getDepartmentTreeManage({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.treeData = data.treeData
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 添加机构
    handleAdd(data) {
      this.showPersonModal = true
      this.personData = {
        type: 'add',
        id: data ? data.id : ''
      }
    },
    closePersonModal(type) {
      if (type === 'refresh') {
        this.getList()
      }
      this.showPersonModal = false
    },
    // 批量删除
    multipleDelete() {
      let selectedIds = this.$refs.personTree.getCheckedKeys()
      console.log(selectedIds)
    },
    // 编辑
    handleEdit(data) {
      this.showPersonModal = true
      this.personData = {
        type: 'edit',
        id: data.id
      }
    },
    // 删除
    handleDelete(data) {
      this.$confirm('是否确定删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          fetch.delDepartment({ id: data.id }).then((data) => {
            data.procData(
              data.res,
              () => {
                this.getList()
                this.$message.success('操作成功')
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less">
.person-container {
  .el-tree-node__content {
    height: 36px;
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
}
</style>
